// Module
var code = "<script id=\"wcc-components-task-topics-slider-topic\" type=\"text/template\">\r\n    <div class=\"task__topics-slider__topic__body\">\r\n        <topic-box-sync params=\"model: topicBoxConfig\"></topic-box-sync>\r\n    </div>\r\n</script>";
// Exports
module.exports = code;